module.exports = __webpack_public_path__ + "static/video-editor-slide-a917247818c5c62b56728beb990e2d79.jpg";